import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function HotelDetails({ hotel, center }) {
  const navigate = useNavigate();
  const { t } = useTranslation('hotel');
  const handleChoose = () => {
    const nextState = {
      hotel,
      hotelId: hotel.id,
      duo_capability: hotel.duo_capability,
      address: hotel.address
    };
    navigate('/hotel-choose-service', { state: nextState });
  };

  return (
    <>
      <div className={`hotel-detail-card ${center ? 'center' : ''}`}>
        <img className='hotel-img' src={hotel.media?.length ? hotel.media[0].original_url : 'assets/images/hotel.png'} alt='hotel_image' />
        {hotel.duo_capability && (<div className='badge-duo'><img src='assets/images/icon-checked.svg' alt='star icon' />DUO</div>)}
        <div className='hotel-name'>{hotel.name}</div>
        <div className='hotel-rating'>
          <img src="/assets/images/icon-stars.svg" alt='star icon' height={13.5} width={13.5} />
          {hotel?.extra?.google_rating?.rating ? (
            `${Number(hotel.extra.google_rating.rating).toFixed(1)}/5 ${hotel.extra.google_rating.user_ratings_total ? `(${hotel.extra.google_rating.user_ratings_total})` : ''}`
          ) : hotel?.extra?.rating ? (
            `${hotel.extra.rating}/5`
          ) : (
            '—'
          )}
        </div>
        <div className='hotel-distance'>{t('distance_from_city_center', { distance: hotel.distance_from_center })}</div>
        {/* <div className='hotel-description'><b>Description: </b>{hotel.description}</div> */}
        <button className='btn-primary' onClick={handleChoose}>{t('choose')}</button>
      </div>
    </>
  );
}

export default HotelDetails;
